<template>
  <div class="LocationPoup">
    <div class="LocationPoup__content">
      <i class="fa fa-question-circle" />
      <p>
        ¿Quieres que te traigamos la comida acasa o prefieres pasar a buscarla?
      </p>
      <a class="btn" target="_blank" href="https://goo.gl/maps/p8y4fhFdb1p">
        <code>DIRECCIÓN, 105 08006 Ibiza</code>
      </a>
      <hr>
      <div class="actions">
        <button class="btn btn-info" @click="setDelivery(false)">LO PASO A BUSCAR</button>
        <button class="btn btn-info" @click="setDelivery(true)">TRAEDMELO A CASA</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    setDelivery(state) {
      this.$emit('setDelivery', state)
    }
  }
}
</script>
<style lang="scss">
.LocationPoup {
  background-color: rgba(0, 0, 0, 0.42);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  padding: 1rem;
  z-index: 1000000000;
  align-items: center;
  justify-content: center;

  &__content {
    background-color: white;
    border-radius: 0.42rem;
    padding: 1rem;
    text-align: center;

    i {
      font-size: 32px;
    }

    .actions {
      display: flex;
      justify-content: space-between;

      .btn {
        font-size: 14px;
        text-align: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Location/LocationPopup.vue